import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "@project-mgmt/ui";
import { FileManagementService, FileValidationService } from "../services/fileService";
export function FilePreview({ file, onDownload, onDelete, showActions = true }) {
    const [isDeleting, setIsDeleting] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const fileIcon = FileManagementService.getFileIcon(file.mimeType || "");
    const fileCategory = FileValidationService.getFileCategory(file.mimeType || "");
    const formattedSize = file.fileSize ? FileValidationService.formatFileSize(file.fileSize) : "Unknown size";
    const uploadDate = new Date(file.uploadedAt).toLocaleDateString();
    const handleDownload = () => {
        onDownload?.(file);
    };
    const handleDeleteClick = () => {
        setShowDeleteConfirm(true);
    };
    const handleDeleteConfirm = async () => {
        setIsDeleting(true);
        try {
            await onDelete?.(file);
        }
        finally {
            setIsDeleting(false);
            setShowDeleteConfirm(false);
        }
    };
    const handleDeleteCancel = () => {
        setShowDeleteConfirm(false);
    };
    const getCategoryColor = (category) => {
        switch (category) {
            case "image":
                return "bg-green-100 text-green-800";
            case "document":
                return "bg-blue-100 text-blue-800";
            case "archive":
                return "bg-purple-100 text-purple-800";
            default:
                return "bg-gray-100 text-gray-800";
        }
    };
    return (_jsxs("div", { className: "flex items-center space-x-4 rounded-lg border border-gray-200 p-4 transition-colors hover:bg-gray-50", children: [_jsx("div", { className: "flex-shrink-0", children: _jsx("div", { className: "flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100 text-xl", children: fileIcon }) }), _jsxs("div", { className: "min-w-0 flex-1", children: [_jsxs("div", { className: "mb-1 flex items-center space-x-2", children: [_jsx("h4", { className: "truncate text-sm font-medium text-gray-900", children: file.filename }), _jsx("span", { className: `inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${getCategoryColor(fileCategory)}`, children: fileCategory })] }), _jsxs("div", { className: "flex items-center space-x-4 text-xs text-gray-500", children: [_jsx("span", { children: formattedSize }), _jsx("span", { children: "\u2022" }), _jsxs("span", { children: ["Uploaded ", uploadDate] }), file.uploaderName && (_jsxs(_Fragment, { children: [_jsx("span", { children: "\u2022" }), _jsxs("span", { children: ["by ", file.uploaderName] })] }))] })] }), showActions && (_jsx("div", { className: "flex items-center space-x-2", children: !showDeleteConfirm ? (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: handleDownload, variant: "outline", size: "sm", children: "Download" }), onDelete && (_jsx(Button, { onClick: handleDeleteClick, variant: "outline", size: "sm", className: "text-red-600 hover:bg-red-50 hover:text-red-700", children: "Delete" }))] })) : (_jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("span", { className: "text-sm text-gray-600", children: "Delete this file?" }), _jsx(Button, { onClick: handleDeleteConfirm, disabled: isDeleting, size: "sm", className: "bg-red-600 text-white hover:bg-red-700", children: isDeleting ? "Deleting..." : "Yes" }), _jsx(Button, { onClick: handleDeleteCancel, variant: "outline", size: "sm", children: "Cancel" })] })) }))] }));
}
